// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_or-0";